// socket 改写 vue-socket.io 插件，使其支持多实例运行

import VueSocketIO from 'vue-socket.io' // 3.0.7及以下采用此种写法

export default function(data = {}, timeout = 10000) {
	// 自带监听事件
	// connect 连接成功
	// connecting 正在连接
	// disconnect 断开连接
	// connect_failed 连接失败
	// error 错误发生，并且无法被其他事件类型所处理
	// reconnect_failed 重连失败
	// reconnect 成功重连
	// reconnecting 正在重连
	
	// global 上下文this(必传)
	// config 连接配置(必传)
	// events 监听事件(非必传)
	// options: {
	// 	autoConnect: false
	// },
	const { global, config, events } = data;
	// 生成实例
	const socket = new VueSocketIO({
		debug: config.debug || false,
		options: config.debug || {},
		connection: config.connection || ''
	});
	// 注册事件
	if (events && typeof events === 'object' && Object.keys(events).length) {
		Object.keys(events).forEach(key => {
			if (typeof events[key] === 'function') {
				socket.emitter.addListener(key, events[key], global);
			}
		});
	}
	// 超出规定时间未能连接成功就销毁
	const timer = setTimeout(function() {
		clearTimeout(timer);
		if (!socket.getConnected()) {
			const error = socket.getListener().get('error');
			if (Array.isArray(error)) {
				// 对订阅了error事件的接收者广播连接失败消息
				for (let { callback, component } of error) {
					callback.call(component, 'connection timed out');
				}
			}
			socket.close();
			socket.destroy();
		}
	}, timeout);
	
	// // 返回新的实例
	// const newSocket = Object.create(null);
	// newSocket['socket'] = socket;
	// newSocket['io'] = socket.io;
	// // newSocket['on'] = (eventName, callback) => socket.emitter.addListener(eventName, callback, global);
	// // newSocket['off'] = (eventName, callback) => socket.emitter.removeListener(eventName, callback);
	// // newSocket['emit'] = (eventName, evnetData) => socket.io.emit(eventName, evnetData);
	// // newSocket['open'] = () => socket.io.open();
	// // newSocket['close'] = () => socket.io.close();
	// // newSocket['connect'] = () => socket.io.connect();
	// return newSocket;
	
	// socket['on'] = (eventName, callback) => socket.emitter.addListener(eventName, callback, global);
	// socket['off'] = (eventName, callback) => socket.emitter.removeListener(eventName, callback);
	// socket['emit'] = (eventName, evnetData) => socket.io.emit(eventName, evnetData);
	// socket['open'] = () => socket.io.open();
	// socket['close'] = () => socket.io.close();
	// socket['connect'] = () => socket.io.connect();
	// socket['destroy'] = () => socket.io.destroy();
	// socket['disconnect'] = () => socket.io.disconnect();
	// socket['getListener'] = () => socket.emitter.listeners;
	socket['on'] = function(eventName, callback) {
		return this.emitter.addListener(eventName, callback, global);
	};
	socket['off'] = function(eventName, callback) {
		return this.emitter.removeListener(eventName, callback);
	};
	socket['emit'] = function(eventName, evnetData) {
		return this.io.emit(eventName, evnetData);
	};
	socket['open'] = function() {
		return this.io.open();
	};
	socket['close'] = function() {
		return this.io.close();
	};
	socket['connect'] = function() {
		return this.io.connect();
	};
	socket['destroy'] = function() {
		return this.io.destroy();
	};
	socket['disconnect'] = function() {
		return this.io.disconnect();
	};
	socket['getListener'] = function() {
		return this.emitter.listeners;
	};
	socket['getConnected'] = function() {
		return this.io.connected;
	};
	return socket;
}


